import { render, staticRenderFns } from "./BlockedCartForm.vue?vue&type=template&id=3c6eb5be&scoped=true"
import script from "./BlockedCartForm.vue?vue&type=script&lang=ts"
export * from "./BlockedCartForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6eb5be",
  null
  
)

export default component.exports